import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/fork/layer.fork.mutation.gql"
import type {
  LayerForkMutation,
  LayerForkMutationVariables,
} from "@/v2-backoffice-client/layer/fork/__types__/layer.fork.mutation"

type Options = MutationHookOptions<
  LayerForkMutation,
  LayerForkMutationVariables
>

export function useLayerForkMutation(options?: Options) {
  return useMutation<LayerForkMutation, LayerForkMutationVariables>(
    mutation,
    options,
  )
}
